import React from 'react';
import ReactDOM from 'react-dom/client';
import { VOLC_HOST } from './apis/constant';
import '@arco-design/web-react/dist/css/arco.css';
import '@byted/volc-editor/lib/Volc/Viewer.css';
import './index.less';
import { jsx as _jsx } from "react/jsx-runtime";
function renderApp(app) {
  const container = document.getElementById('root'); // document.body.setAttribute('arco-theme', 'dark');
  const root = ReactDOM.createRoot(container);
  root.render(app);
}
async function bootstrap(loadPromise) {
  const App = await loadPromise; // 最后引入 tailwind css，确保样式优先级 > arco-design
  await import( /** tailwind style */'./index.css');
  renderApp( /*#__PURE__*/_jsx(App.default, {}));
}
const isVolc = !!process.env.REACT_APP_VOLC || VOLC_HOST.includes(window.location.hostname);
if (isVolc) {
  bootstrap(import('./page-volc/app'));
} else {
  bootstrap(import('./page/app'));
}